import React, { Fragment, useEffect, forwardRef, useImperativeHandle, useRef } from 'react'
import { Checkbox, Grid, Typography } from '@mui/material';
import cssClasses from "./CreateUser.module.css";
import assignProjectImage from '../../../Assets/Images/Project images/Frame 1208.svg'
import { CheckBox, Padding } from '@mui/icons-material';
import { useState } from 'react';
import { addSelectedProjects, getAllProjects, getSelectedProjects } from '../../../Services/AssignProject';
import Button from '../../../Subcomponents/Button';
import { successTost } from '../../../Services/Toast';
import { updateUser } from '../../../Services/Users';
import { useNavigate } from 'react-router-dom';


const AssignProject = forwardRef(({ userObject, onTabChange }, ref) => {

  const navigate = useNavigate();

  const isLeaveComponentPromise = useRef(null);

  const [checkedProjects, setCheckedProjects] = useState([]);

  const [selectedProjects, setSelectedProjects] = useState([]);

  const [projects, setProjects] = useState([]);

  const [unselectedProject, setUnselectedProject] = useState([]);

  const [unCheckedProjects, setUnCheckedProjects] = useState([]);


  useEffect(() => {
    allProjects();
  }, [])

  async function allProjects() {

    const { data } = await getAllProjects();
    const fetchSelectedProjects = await getSelectedProjects(userObject.userId);

    let array1 = [];
    let array2 = [];

    fetchSelectedProjects.data.map((item) => {
      array2.push(item.projectId);
    })

    setSelectedProjects(array2);

    data.map((item) => {
      array1.push({
        ...item,
        selected: array2.includes(item.projectId) ? true : false
      });
    });

    console.log('all insetred project id : ', fetchSelectedProjects.data)



    setProjects(array1);
  }

  const handleChange = async (event, projectId, userId) => {
    if (event.target.checked) {
      setSelectedProjects([...selectedProjects, projectId])

      setUnselectedProject(unselectedProject.filter(function (item, idx) {
        return item !== projectId;
      }))

    } else {
      setSelectedProjects(selectedProjects.filter(function (item, idx) {
        return item !== projectId;
      }))
      setUnselectedProject([...unselectedProject, projectId]);
    }
  };


  useEffect(() => {
    console.log('unselected project', unselectedProject);
    let items = [];
    unselectedProject.map((item) => {
      items.push({ userId: userObject.userId, projectId: item, last_updated_at: Date.now() });
    })

    setUnCheckedProjects(items);

  }, [unselectedProject])


  useEffect(() => {
    let array1 = [];
    projects.map((item) => {
      array1.push({
        ...item,
        selected: selectedProjects.includes(item.projectId) ? true : false
      });
    });

    let items = [];

    selectedProjects.map((item) => {
      items.push({ userId: userObject.userId, projectId: item, last_updated_at: Date.now() });
    })

    setCheckedProjects(items);
    setProjects(array1);
  }, [selectedProjects]);


  useEffect(() => {
    console.log('checked projects : ', checkedProjects);
  }, [checkedProjects])


  const handleSave = async () => {
    if (checkedProjects) {
      addSelectedProjects(checkedProjects, unCheckedProjects).then((resp) => {
        console.log('resp: ', resp);
        updateUser({
          roleId: userObject.roleId,
          parentId: userObject.parentId,
          completedTabs: (!userObject.completedTabs.includes('Assigned Projects')) ? [...userObject.completedTabs, 'Assigned Projects'] : userObject.completedTabs
        }, userObject.userId).then((response) => {
          console.log('response: ', response);
          successTost('Project Assigned Successfully');
          navigate("/home/users");
        }).catch((err) => {
          console.log('err: ', err);
        });
      }).catch((err) => {
        console.log('err: ', err);
      });

      // allProjects();

    }

  }

  function isLeaveComponent() {
    // return new Promise((resolve, reject) => {
    //   if (userObject.name === user.name && userObject.email === user.email && userObject.contactNumber === user.contactNumber) {
    //     resolve(true);
    //   } else {
    //     setConfirmationAlertToggler(true);
    //     isLeaveComponentPromise.current = resolve;
    //   }
    // })
    return true;
  }

  useImperativeHandle(ref, () => ({
    isLeaveComponent
  }));

  function goToBack() {
    onTabChange("Assign Role");
  }

  const [projectSearch, setProjectSearch] = React.useState("");

  // Currently-visible projects (respects the search box).
  const visibleProjects = projects.filter(
    (p) => !projectSearch || p.projectName?.toLowerCase().includes(projectSearch.toLowerCase())
  );

  // Select All / Clear operate on the visible set: with no search that's every
  // project; with a search active it's just the filtered ones.
  const selectAllProjects = () => {
    const ids = visibleProjects.map((p) => p.projectId);
    const idSet = new Set(ids);
    setSelectedProjects((prev) => Array.from(new Set([...prev, ...ids])));
    setUnselectedProject((prev) => prev.filter((id) => !idSet.has(id)));
  };

  const clearAllProjects = () => {
    const ids = visibleProjects.map((p) => p.projectId);
    const idSet = new Set(ids);
    setSelectedProjects((prev) => prev.filter((id) => !idSet.has(id)));
    setUnselectedProject((prev) => Array.from(new Set([...prev, ...ids])));
  };

  return (
    <>
      <div style={{ overflow: "auto", flex: "1", marginBottom: "1rem", padding: "1rem 1.6rem" }}>
        {/* Search */}
        <input
          type="text"
          placeholder="Search projects..."
          onChange={(e) => setProjectSearch(e.target.value)}
          style={{
            width: "100%", padding: "0.8rem 1.2rem", fontSize: "1.4rem",
            fontFamily: "Inter-Medium", border: "1px solid #D0D5DD",
            borderRadius: "0.8rem", marginBottom: "1.2rem", outline: "none", color: "#101828",
          }}
        />
        {/* Select All / Clear toolbar */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1.2rem" }}>
          <span style={{ fontSize: "1.3rem", fontFamily: "Inter-Medium", color: "#667085" }}>
            {selectedProjects.length} selected
          </span>
          <div style={{ display: "flex", gap: "1.4rem", alignItems: "center" }}>
            <span
              onClick={selectAllProjects}
              style={{ cursor: "pointer", fontSize: "1.3rem", fontFamily: "Inter-Medium", color: "#1570EF", fontWeight: 500 }}
            >
              Select All
            </span>
            <span style={{ color: "#D0D5DD" }}>|</span>
            <span
              onClick={clearAllProjects}
              style={{ cursor: "pointer", fontSize: "1.3rem", fontFamily: "Inter-Medium", color: "#B42318", fontWeight: 500 }}
            >
              Clear
            </span>
          </div>
        </div>
        {/* Project list — name only */}
        <div style={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}>
          {visibleProjects
            .map(({ projectName, projectId, selected }) => (
              <div
                key={projectId}
                onClick={() => handleChange({ target: { checked: !selected } }, projectId, userObject.userId)}
                style={{
                  display: "flex", alignItems: "center", gap: "1.2rem",
                  padding: "1rem 1.4rem", borderRadius: "0.8rem",
                  border: selected ? "1.5px solid #1570EF" : "0.5px solid #EAECF0",
                  background: selected ? "#EFF8FF" : "#FFFFFF",
                  cursor: "pointer",
                }}
              >
                <Checkbox
                  checked={selected ? true : false}
                  onChange={(e) => handleChange(e, projectId, userObject.userId)}
                  onClick={(e) => e.stopPropagation()}
                  sx={{ padding: 0 }}
                />
                <Typography style={{
                  fontSize: "1.4rem", fontFamily: "Inter-Medium",
                  color: selected ? "#0C447C" : "#344054",
                  fontWeight: selected ? "500" : "400",
                }}>
                  {projectName}
                </Typography>
              </div>
            ))}
        </div>
      </div>

      <div className={cssClasses.buttonWrapper}>
        <div>
          <Button
            style={{
              color: "#fff",
              backgroundColor: "#D0D5DD",
              fontSize: "1.4rem",
              lineHeight: "2rem",
              fontFamily: "Roboto-Regular",
            }}
            btnName={"Back"}
            clicked={goToBack}
            // btnIcon={<AddIcon style={{width: "15px", height: "15px"}}/>}
            iconPosition={"left"}
          // disable={!(userChildData?.roleId && userChildData?.parentId)}
          />
        </div>
        <div>
          <Button
            style={{
              color: "#fff",
              backgroundColor: "#1570EF",
              fontSize: "1.4rem",
              lineHeight: "2rem",
              fontFamily: "Roboto-Regular"
            }}
            btnName={"Save  Details"}
            clicked={() => {
              handleSave();
            }}
            // btnIcon={<AddIcon style={{width: "15px", height: "15px"}}/>}
            disable={(selectedProjects[0]) ? false : true}
            iconPosition={"left"}
          />
        </div>
      </div>
    </>
  )
})

export default AssignProject